import React from 'react';
import ReactDOM from 'react-dom';
import 'mdb-react-ui-kit/dist/css/mdb.min.css'
import { MetaMaskProvider } from "metamask-react";

import './index.css';
import App from './App';
import "nes.css.14x/css/nes.min.css";

ReactDOM.render(
  <React.StrictMode>
    <MetaMaskProvider>
    <App />
    </MetaMaskProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
